// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const MenuIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
          <path fill="inherit" d="M88.4 31.3c3.9 0 6.7-2.8 6.7-6.6s-2.8-6.8-6.7-6.8H11.7c-3.8 0-6.8 3-6.8 6.8s3 6.6 6.8 6.6h76.7zM11.7 68.7c-3.8 0-6.8 3-6.8 6.7s3 6.8 6.8 6.8h76.8c3.9 0 6.7-3.1 6.7-6.8 0-3.7-2.8-6.7-6.7-6.7H11.7zm0-25.5c-3.8 0-6.8 3-6.8 6.8s3 6.8 6.8 6.8h76.8c3.9 0 6.7-3 6.7-6.8s-2.8-6.8-6.7-6.8H11.7z"/>
        </svg>
      )
    }
  </Icon>
);

export default MenuIcon;
